import { render, staticRenderFns } from "./Publishers.vue?vue&type=template&id=be4ae7ca&scoped=true&"
import script from "./Publishers.vue?vue&type=script&lang=js&"
export * from "./Publishers.vue?vue&type=script&lang=js&"
import style0 from "./Publishers.vue?vue&type=style&index=0&id=be4ae7ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ae7ca",
  null
  
)

export default component.exports